<template>
  <div class="link-demo">
    <div class="demo-pages">
      <div class="demo-page">
        <p class="demo-page-label">Page 3 · a sentence</p>
        <div class="demo-cell">
          <span>Mechanical ventilation systems, fire-rated ducts and smoke control are required in certain buildings (4).</span>
        </div>
      </div>
      <div class="demo-page">
        <p class="demo-page-label">Page 5 · the note</p>
        <div class="demo-note" :class="{ linked: linked }">
          <span class="demo-note-tag">Note (4)</span>
          <span>Building services include mechanical ventilation, fire-rated ducts, smoke control and their control panels.</span>
        </div>
      </div>
    </div>
    <button class="demo-toggle" type="button" @click="linked = !linked">
      {{ linked ? 'Unlink' : 'Connect the reference' }}
    </button>
    <transition name="demo-fade">
      <div v-if="linked" class="demo-result">
        <p class="demo-result-label">The chunk after linking</p>
        <p class="demo-result-text">
          Mechanical ventilation systems, fire-rated ducts and smoke control are required in certain buildings
          <em>(4)</em>. <em>Note (4).</em> Building services include mechanical ventilation, fire-rated ducts,
          smoke control and their control panels.
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ReferenceLinkingDemo',
  data() {
    return { linked: false };
  },
};
</script>

<style scoped>
.link-demo {
  margin: 1.4em 0;
  padding: 1.3em 1.4em 1.5em;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  background: #fafafa;
}
.demo-pages {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.1em;
}
.demo-page {
  display: flex;
  flex-direction: column;
}
.demo-page-label {
  margin: 0 0 0.45em;
  font-family: "Quattrocento Sans", sans-serif;
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9a9a9a;
}
.demo-cell,
.demo-note {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.35em;
  padding: 0.8em 0.9em;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: #fff;
  font-size: 0.9rem;
  transition: box-shadow 0.25s ease, border-color 0.25s ease;
}
.demo-note.linked {
  border-color: rgba(128,128,128,0.5);
  box-shadow: 0 0 0 3px rgba(128,128,128,0.12);
}
.demo-note-tag {
  font-family: "Quattrocento Sans", sans-serif;
  font-weight: 700;
  color: #333;
}
.demo-toggle {
  display: block;
  margin: 1.1em auto 0;
  padding: 0.45em 1.3em;
  border: 1px solid rgba(0, 0, 0, 0.22);
  border-radius: 999px;
  background: transparent;
  font-family: "Quattrocento Sans", sans-serif;
  font-size: 0.85rem;
  letter-spacing: 0.04em;
  cursor: pointer;
  color: #333;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.demo-toggle:hover {
  background: #333;
  color: #fff;
  border-color: #333;
}
.demo-result {
  margin-top: 1.1em;
  padding: 0.9em 1em;
  border-left: 3px solid rgba(128,128,128,0.7);
  background: rgba(128,128,128,0.07);
  border-radius: 0 8px 8px 0;
}
.demo-result-label {
  margin: 0 0 0.35em;
  font-family: "Quattrocento Sans", sans-serif;
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--site-accent);
}
.demo-result-text {
  margin: 0;
  font-size: 0.94rem;
  line-height: 1.6;
}
.demo-fade-enter-active,
.demo-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.demo-fade-enter-from,
.demo-fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

body.dark-mode .link-demo {
  background: #262628;
  border-color: rgba(255, 255, 255, 0.12);
}
body.dark-mode .demo-cell,
body.dark-mode .demo-note {
  background: #2c2c2e;
  border-color: rgba(255, 255, 255, 0.14);
}
body.dark-mode .demo-note-tag {
  color: #ececec;
}
body.dark-mode .demo-toggle {
  border-color: rgba(255, 255, 255, 0.3);
  color: #e5e5e5;
}
body.dark-mode .demo-toggle:hover {
  background: #e5e5e5;
  color: #1c1c1e;
  border-color: #e5e5e5;
}

@media (max-width: 640px) {
  .demo-pages {
    grid-template-columns: 1fr;
  }
}

@container (max-width: 640px) {
  .demo-pages {
    grid-template-columns: 1fr;
  }
}
</style>
